export default "__VITE_ASSET__ePRTlx8u__"